import * as diagnosisService from "./service";
const Model = {
  namespace: 'diagnosis',
  state: {
    eventData: {},
  },
  effects: {
    // 获取报告大纲列表
    getReportOutlineData({ payload }: any, { call }: any) {
      return call(diagnosisService.getReportOutline, payload);
    },
  },
  reducers: {

  },
};
export default Model;
